(function () {
    angular
        .module('MktzapApp.Controllers')
        .requires
        .push(
            'ngTable'
        );

    angular.module('MktzapApp.Controllers')
        .controller('AttendanceIdentificationController', reports);

    reports.$inject = ['LangService', '$scope', '$http', '$state', 'ngTableParams', 'AttendanceIdentificationService', 'NotificationService'];

    function reports(LangService, $scope, $http, $state, ngTableParams, AttendanceIdentificationService, NotificationService) {

        let vm = this;

        vm.labels = {};

        vm.filters = {
            fromDate: moment().startOf("month").format("DD/MM/YYYY"),
            toDate: moment().endOf("month").format("DD/MM/YYYY"),
        };

        vm.selectedCompanies = [];
        vm.selectedCompaniesIds = [];
        vm.filterSelected = {filter: 'name', status: 0}

        vm.disableSelectCompanies = false

        getAllRequests();
        getCompanies();

        LangService
            .getPageLabels({'page':'menu.reports.attendance-identification'})
            .$promise
            .then(function(data) {
                vm.labels = data.lang;
            });

        vm.dateSelected = function (type, date) {
            if (type == 'from') {
                vm.pkadayToDate.setMinDate(date);
            }
            if (type == 'to') {
                vm.pkadayFromDate.setMaxDate(date);
            }
        };

        $scope.$watch('vm.filterSelected.filter', function() {
            vm.filterSelected.text = ""
            vm.filterSelected.date = ""
            vm.filterSelected.status = "0"
        })

        function getAllRequests () {
            vm.requestsTable = new ngTableParams({
                page: 1, 
                count: 15, 
            }, {
                counts: [25, 50, 100],
                getData: function ($defer, params) {
                    var obj = params.url();
                    obj = {
                        page: obj['page'],
                        count: obj['count']
                    }
                    AttendanceIdentificationService
                        .paged(obj)
                        .$promise
                        .then(function (retorno) {
                            params.total(retorno.data.total);
                            $defer.resolve(retorno.data.data);
                        }).catch(function ({ data }) {
                            const errors = data.errors.validation
                            if (errors) {
                                errors.map(function (message) {
                                    NotificationService.warningHandler(null, message)
                                })
                            } else {
                                NotificationService.errorHandler(null, data.errors)
                            }
                        })
                }
            })
        }

        vm.sendEmail = () => {
            angular.forEach(vm.selectedCompanies, function(value) {
                this.push(value.id)
            }, vm.selectedCompaniesIds);
            if (!vm.selectedCompaniesIds[0]) {
                    NotificationService.errorHandler('', vm.labels.formValidation_companiesIds_required)
                return false
            }
            vm.filters.companiesIds = vm.selectedCompaniesIds;
            $http.post(apiUrl + '/security/attendance-identification-email', vm.filters)
                .then(({ data }) => {
                    if (data.warning) {
                        NotificationService.warningHandler(data, data.message)
                        return
                    }
                    $state.reload()
                    NotificationService.successHandler('', vm.labels.sendEmail_sucess)
                },
                (error) => {
                    NotificationService.errorHandler('', error.data.errors.validation)
                }
            )
        }

        function getCompanies() {
        AttendanceIdentificationService
            .getAllCompanies()
            .$promise
            .then(function (data) {
                if (data.companies) {
                    vm.companies = data.companies;
                } else {
                    NotificationService.errorHandler(data, vm.labels.getcompanies_error);
                }
            });
        }

        vm.changeTagsCompanies = (action) => {
            if (vm.isLord || action === 'removed') {
                vm.disableInputCompanies = false
                return
            }
        
            vm.disableInputCompanies = true
        }

        vm.autocompleteFilterCompany = function ($query) {
            return vm.companies.filter(function ($company) {
                return $company.name.toLowerCase().indexOf($query.toLowerCase()) != -1
            })
        }

        vm.refreshPage = () => {
            $state.reload()
        }

        vm.applyFilter = function() {
            if (!vm.filterSelected.filter) {
                NotificationService.errorHandler('', vm.labels.noFilterSelected)
            return false
            }
            vm.requestsTable = new ngTableParams({
                page: 1, 
                count: 15, 
            }, {
                counts: [25, 50, 100],
                getData: function ($defer, params) {
                    var obj = params.url();
                    obj = {
                        page: obj['page'],
                        count: obj['count'],
                        filter: vm.filterSelected.filter,
                        text: vm.filterSelected.text,
                        date: vm.filterSelected.date,
                        status: vm.filterSelected.status,
                    }
                    AttendanceIdentificationService
                        .paged(obj)
                        .$promise
                        .then(function (retorno) {
                            params.total(retorno.data.total);
                            $defer.resolve(retorno.data.data);
                        }).catch(function ({ data }) {
                            const errors = data.errors.validation
                            if (errors) {
                                errors.map(function (message) {
                                    NotificationService.warningHandler(null, message)
                                })
                            } else {
                                NotificationService.errorHandler(null, data.errors)
                            }
                        })
                }
            })
        }
    }
})();
